export const ThemeBG1 = "#ebf6ff";

//https://shivapdf.com/scripts/backend.php
export const REQUEST_URL = "https://shivapdf.com/scripts/backend.php";
//https://shivapdf.com/scripts/query_form.php
export const QUERY_FORM_URL = "https://shivapdf.com/scripts/query_form.php";
//server authentication url
//https://shivapdf.com/scripts/authentication.php
export const AUTHENTICATION_URL =
  "https://shivapdf.com/scripts/authentication.php";

//base url
export const BASE_URL = "https://shivapdf.com";

//temp file storage database name
export const TMP_DB_NAME = "my_files_storage_db";

//runpod status check interval
export const STATUS_CHECK_INTERVAL = 3000; // 3 seconds
//max file size that can be uploaded
//runpod datauri method only supports 10 mb max
//for higher limit we need to upload original file as multipart data
//also change this value on server config.php file
export const MAX_UPLOAD_FILE_SIZE = 1024 * 1024 * 30;
